import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	nameIsTakenTitle: {
		id: 'work-management-board.common.utils.validate-column-name.name-is-taken-title',
		// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
		defaultMessage: "''{name}'' is already a status name in this project",
		description:
			'Title of the warning message to let the user know that they have chosen a column name that already exists',
	},
	nameIsTakenDescription: {
		id: 'work-management-board.common.utils.validate-column-name.name-is-taken-description',
		defaultMessage: 'Give your column’s status a different name.',
		description:
			'Description of the warning message telling the user to enter a different column name',
	},
});
